import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { withMockLabFacilities } from "features/labOrders/mockFacilities";

// Hospital laboratories this practice can order from (KIN-1390).
//
// Filtered server-side, unlike the general available-services directory the
// referral flow consumes: laboratory capability is not derivable client-side, and
// a facility without Healthlink's Integrated Browser cannot be ordered from at
// all. An empty list is a valid answer — "no laboratory accepts electronic orders
// for this practice yet" is a state, not a failure.
export const useLabOrderFacilities = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["labOrderFacilities", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/healthlink/lab-orders/facilities`
      );

      const facilities = Array.isArray(response?.data) ? response.data : [];

      // Dev-only: Healthlink publishes no lab-capable facility yet, so without this
      // the picker has nothing to pick. Off unless explicitly enabled.
      return withMockLabFacilities(facilities);
    },
    enabled: !!tenantVal,
    staleTime: 1000 * 60 * 5,
  });
};
